import { Button } from "common/src/styles";
import { LinkIcon } from "@heroicons/react/24/solid";
import { useState } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function CopyToClipboardButton(props) {
  const [active, setActive] = useState(false);
  return /*#__PURE__*/_jsxs(Button, {
    type: "button",
    className: `inline-flex text-black w-30 justify-center text-sm font-semibold bg-white border border-grey-100 ${props.styles}`,
    onClick: async () => {
      setActive(true);
      setTimeout(() => setActive(false), 1000);
      await navigator.clipboard.writeText(props.textToCopy);
    },
    children: [/*#__PURE__*/_jsx(LinkIcon, {
      className: `mt-1 ${props.iconStyle}`,
      "aria-hidden": "true"
    }), /*#__PURE__*/_jsx("span", {
      className: "ml-1",
      children: active ? "Link Copied" : "Share Profile"
    })]
  });
}